import React from 'react';
import {
  Button,
  Copy,
  Flex,
  Heading,
  Square,
  Stack,
  SvgExclamation,
} from '@grubhubprod/gh-cookbook-react';
import { getWindow } from 'src/utilities/window';
import {
  InsightsErrorStateVariant,
  getBusinessAdminInsightsErrorStateCopy,
} from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/BusinessAdminInsightsErrorState/BusinessAdminInsightsErrorState.utils';

export interface BusinessAdminInsightsErrorStateProps {
  variant: InsightsErrorStateVariant;
}

export function BusinessAdminInsightsErrorState({
  variant,
}: BusinessAdminInsightsErrorStateProps): JSX.Element {
  const copy = getBusinessAdminInsightsErrorStateCopy(variant);
  const showRefreshAction = !!copy.refreshActionLabel;

  const window = getWindow();
  const handleRefreshActionClick = (): void => {
    window.location.reload();
  };

  return (
    <Square bg="untintedBackground" borderRadius="medium" padding={16}>
      <Flex flexDirection="column" alignItems="center">
        <Stack y="x-sm">
          <Copy variant="body" color="danger">
            <SvgExclamation size="32px" />
          </Copy>
        </Stack>

        <Stack y="xxx-sm">
          <Heading variant="h4" color="danger" textAlign="center">
            {copy.title}
          </Heading>
        </Stack>

        <Stack y={showRefreshAction ? 'lg' : 'none'}>
          <Copy variant="body" color="secondaryText" textAlign="center">
            {copy.description}
          </Copy>
        </Stack>

        {showRefreshAction && (
          <Button
            variant="secondary"
            buttonSize="small"
            onClick={handleRefreshActionClick}
          >
            {copy.refreshActionLabel}
          </Button>
        )}
      </Flex>
    </Square>
  );
}
